export default "__VITE_ASSET__15cd5f7d__"